import React, { FunctionComponent } from "react";
import "./index.scss";

export const deploymentBlueprintForGcpUrl = "https://thoughtworks.atlassian.net/wiki/spaces/ALLGIEA/pages/1290469478/Deployment+Blueprint+for+GCP";

// Used on the Infrastructure Configuration wizard step and the Manage Infrastructure tab.
export const DeploymentBlueprintNotice: FunctionComponent = () => (
  <p className="DeploymentBlueprintNotice">
    <span className="new-badge">New</span>
    {" "}
    Minimizing our public internet exposure is a top priority for all teams. To support this effort and prevent security
    incidents, we have established a foundational blueprint towards zero-trust network connectivity. Please review this guide
    to ensure your network perimeters are fully secured before deploying your workloads.
    {" "}
    <a
      href={deploymentBlueprintForGcpUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      Deployment Blueprint for GCP
    </a>
  </p>
);

// Used on the Review & Submit page's Acknowledgement checkbox.
export const DeploymentBlueprintAcknowledgmentNotice: FunctionComponent = () => (
  <p className="DeploymentBlueprintNotice">
    <span className="new-badge">New</span>
    {" "}
    Please review the attached
    {" "}
    <a
      href={deploymentBlueprintForGcpUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      network perimeter blueprint
    </a>
    {" "}
    to help lock down our attack surface and reduce exposure. These security controls are currently strongly recommended,
    but will soon become mandatory policies. Implementing these guardrails today will keep your deployments secure and
    compliant ahead of the deadline.
  </p>
);

export default DeploymentBlueprintNotice;
